'use client';

import { type StaticImport } from 'next/dist/shared/lib/get-img-props';
import Image, { type ImageProps } from 'next/image';
import { useEffect, useState } from 'react';

export type ImageWithFallbackProps = {
  blurImage?: string;
  fallbackSrc?: string | StaticImport;
} & ImageProps;

export const ImageWithFallback = ({
  blurImage,
  fallbackSrc,
  loader,
  src,
  ...rest
}: ImageWithFallbackProps) => {
  const [error, setError] = useState(false);

  useEffect(() => {
    setError(false);
  }, [src]);

  return (
    <Image
      {...rest}
      alt={rest.alt}
      blurDataURL={blurImage}
      loader={error || !src ? undefined : loader}
      onError={() => setError(true)}
      placeholder={blurImage ? 'blur' : 'empty'}
      src={(error || !src) && fallbackSrc ? fallbackSrc : src}
    />
  );
};
